import React from "react";
function Statistics(){
    return(
        <div>Statistics em construção</div>
    )
}
export default Statistics